module.exports = __webpack_public_path__ + "img/21).66203e86.png";